import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';

import SignatureCanvas from 'react-signature-canvas';

import i18n from '../../i18n';

export default function SignaturePad({ onSaveImage, onBack }) {
    const sigCanvas = useRef(null);

    // Čišćenje potpisa
    const clear = () => {
        sigCanvas.current.clear();
    };

    // Pretvaranje Base64 u File
    const dataURLtoFile = (dataURL, filename) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };

    // Snimanje i slanje Laravelu
    const saveAndSend = async () => {
        if (!sigCanvas.current || typeof sigCanvas.current.getTrimmedCanvas !== 'function') {
            alert('SignaturePad is not ready!');
            return;
        }
        const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');

        const file = dataURLtoFile(dataURL, 'signature.png');

        const formData = new FormData();
        formData.append('signature', file);

        try {
            onSaveImage(formData);
        } catch (error) {
            console.error('Greška prilikom slanja', error);
        }
    };

    // const back = () => {
    //     if (onBack) {
    //         onBack();
    //     }
    // };

    // function trim() {
    //     setTrimmedDataURL(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
    // }

    return (
        <div className="w-full">
            <div className="flex justify-content-center">
                <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    backgroundColor="rgba(0,0,0,0)" // transparentna pozadina
                    canvasProps={{ width: 500, height: 300, className: 'bg-orange-100' }}
                />
            </div>

            <div className="flex justify-content-between mt-2 mb-4">
                <Button onClick={saveAndSend} label={i18n.t('save')} />
                {/* <Button outlined onClick={back} label={i18n.t('back')} /> */}
                <Button onClick={clear} label={i18n.t('clear')} />

                {/* <Button onClick={trim} label="Trim" /> */}
            </div>
            {/* {trimmedDataURL ? <img className={'w-4'} alt="signature" src={trimmedDataURL} /> : null} */}
        </div>
    );
}
